import { render, staticRenderFns } from "./MenuCertificados.vue?vue&type=template&id=8d1be624&scoped=true"
import script from "./MenuCertificados.vue?vue&type=script&lang=js"
export * from "./MenuCertificados.vue?vue&type=script&lang=js"
import style0 from "./MenuCertificados.vue?vue&type=style&index=0&id=8d1be624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1be624",
  null
  
)

export default component.exports